import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { space, device, H2, H4 } from '@ticketswap/solar'
import { createMarkup } from '~/utils'
import AppsAdoptionAlert from '~/components/AppsAdoptionAlert'

const ItemWrapper = styled.div`
  margin-bottom: ${space[8]};

  @media ${device.tablet} {
    margin-bottom: ${space[16]};
  }
`

const StyledH4 = styled(H4)`
  margin-bottom: ${space[16]};
`

const NoAvailableTickets = ({
  t,
  status,
  isSoldDeletedOrReserved,
  userHasActiveTicketAlertsForCurrentListing,
  currentViewer,
  eventName,
}) => (
  <>
    <ItemWrapper>
      <H2
        dangerouslySetInnerHTML={createMarkup(
          t(
            `listing:purchaser.${
              status.eventIsExpired
                ? 'expiredEvent'
                : status.eventTypeIsExpired
                ? 'expiredEventType'
                : status.listingIsSold
                ? 'soldListing'
                : status.listingIsDeleted
                ? 'deletedListing'
                : 'reservedListing'
            }.title`
          ),
          {
            renderInline: true,
          }
        )}
      />

      {isSoldDeletedOrReserved && (
        <StyledH4
          dangerouslySetInnerHTML={createMarkup(
            t(
              `listing:purchaser.${
                status.listingIsSold
                  ? userHasActiveTicketAlertsForCurrentListing
                    ? 'soldListing.text.withTicketAlerts'
                    : 'soldListing.text.regular'
                  : status.listingIsDeleted
                  ? 'deletedListing.text'
                  : 'reservedListing.text'
              }`
            ),
            {
              renderInline: true,
            }
          )}
        />
      )}
    </ItemWrapper>

    {(!currentViewer || currentViewer?.userDevices?.length === 0) && (
      <AppsAdoptionAlert
        title={t('listing:appsAdoption.listingSold.title')}
        text={t('listing:appsAdoption.listingSold.text', {
          eventName,
        })}
        trackingContext="SOLD_LISTING"
      />
    )}
  </>
)

NoAvailableTickets.propTypes = {
  status: PropTypes.shape({
    eventIsExpired: PropTypes.bool,
    eventTypeIsExpired: PropTypes.bool,
    listingIsSold: PropTypes.bool,
    listingIsDeleted: PropTypes.bool,
  }).isRequired,
}

export default NoAvailableTickets
